import React from 'react';
import { useTheme } from '@mui/material';

export function MyCoolGradient(): JSX.Element {
  const theme = useTheme();

  return (
    <svg
      style={{
        width: '25px',
        height: '25px',
        position: 'absolute',
      }}
      aria-hidden="true"
      focusable="false"
    >
      <linearGradient id="my-cool-gradient" x2="0" y2="1">
        <stop offset="0%" stopColor={`${theme.palette.primary.main}`} />
        <stop offset="100%" stopColor={`${theme.palette.secondary.main}`} />
      </linearGradient>
    </svg>
  );
}
